import React__default from 'react';
import createSvgIcon from '../utils/createSvgIcon.js';
import '../SvgIcon-0b8a779c.js';
import 'classnames';

var Email = createSvgIcon(React__default.createElement("path", { d: "M12 11.662L5.6302 6L18.3698 6L12 11.662ZM4 16.3386L4 7.22684L8.48467 11.2132L4 16.3386ZM5.20377 18L19 18L14.5521 12.0694L12.6644 13.7474L12 14.338L11.3356 13.7474L9.97953 12.542L5.20377 18ZM16.0521 10.7361L20 16L20 7.22684L16.0521 10.7361ZM4 4H2L2 6L2 18L2 20H4L20 20H22V18L22 6V4L20 4L4 4Z", fillRule: "evenodd" }), 'Email');

export { Email };
